import React, { Component } from 'react';
import '../App.css';
import '../Style/General.css';
import '../Style/NeuralNetwork.css';
import { injectSearch } from '../Search.js';

class Generator extends Component {
  render() {
    const names = [];
    for (var i = 0; i < this.props.content.length; ++i) {
      if (this.props.content[i] !== "RNN failed!") {
        if (i < this.props.content.length - 1) {
          names.push(<span className="NameObject" key={i} onClick={this.onNameClick.bind(this, this.props.content[i])}>
            {this.props.content[i]}
            <span className='NeuralDivider'>,</span>
          </span>)
        } else {
          names.push(<span className="NameObject" key={i} onClick={this.onNameClick.bind(this, this.props.content[i])}>
            {this.props.content[i]}
          </span>)
        }
      }
    }

    if (Object.keys(this.props.content).length !== 0) {
      return (
          <div className="NameList">
            {names}
          </div>
      );
    } else {
      return (
          <div className="NameList">
           <span className="NameObject__loading">Loading...</span>
          </div>
      );
    }
  }

  onNameClick(text) {
    injectSearch.callback(text);
  }
}

export default Generator;



// WEBPACK FOOTER //
// ./client/src/Engines/Generator.js